import React, {createContext, useContext, useEffect, useState} from 'react';
import {getSessionUser} from "../app/common/api/WebApi";
import {useLocation, useNavigate} from "react-router-dom";
import {CONSTANTS} from "../app/common/constants";
import {CartContext} from "./CartProvider";

export const UserContext = createContext({
  sessionUser: {},
  authenticated: false,
  showLogin: false,
  refreshIdentity: false,
  reloadEvents: false,
  reloadInvoices: false,
  assignedWaivers: [],
  loginNag: false
});


export const UserProvider = (props) => {

  const [cartContext, setCartContext] = useContext(CartContext);

  const [context, setContext] = useState({
    sessionUser: {},
    authenticated: false,
    showLogin: false,
    refreshIdentity: false,
    reloadEvents: false,
    assignedWaivers: [],
    reloadInvoices: false,
    loginNag: false
  });
  const [pingTimer, setPingTimer] = useState(new Date().getTime());
  const navigate = useNavigate();
  const {pathname} = useLocation();

  useEffect(() => {
    getSessionUser(window.location.href + '/' + pathname).then((user) => {
      if (!user) {
        setContext({...context, showLogin: true});
      } else if (JSON.stringify(context.sessionUser) !== JSON.stringify(user)) {
        let _c = {...context};
        _c.sessionUser = user;

        if (user.userTypeId === CONSTANTS.UTYPE_CLIENT && !user.guid) {
          _c.showLogin = true;
          setContext({..._c});
          if (!pathname.match('/pass/reset/')) {
            navigate('/login');
          }
        }
        _c.refreshIdentity = false;
        setContext({..._c});
      }
      setCartContext({...cartContext, reloadCart: true});
    });

    let interval = null;
    interval = setInterval(() => {
      setPingTimer(new Date().getTime());
      clearInterval(interval);
    }, 60000);
  }, [pingTimer, context.refreshIdentity]);

  return (
    <UserContext.Provider value={[context, setContext]}>
      {props.children}
    </UserContext.Provider>
  )
}